<template>
  <div >
    <h2>欢迎来到好同志光电管理系统</h2>
    <el-image
        style="width: 300px; height: 300px"
        :src="require('@/assets/download.png')"
    ></el-image>
    <br>
    <el-link type="primary"  href="http://api.gw.duhongtech.com/sight/app/apk/newapk">扫描上方二维码或点击链接下载app</el-link>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>

</style>
